export default class DateService {
  toDateOnlyStr = (date: unknown) => {
    if (!date || !(date instanceof Date)) return undefined;
    return `${date.getFullYear()}-${`${date.getMonth()+1}`.padStart(2, '0')}-${`${date.getDate()}`.padStart(2, '0')}`
  }

  toDateOnlyFromAPI = (date: unknown) => {
    if (!date) return undefined;
    if (!(typeof date === 'string')) return undefined;
    const d = date.split("-").map(p => parseInt(p));
    return new Date(d[0], d[1] - 1, d[2]);
  }

  // Agrega o quita días, meses o años a una fecha Date
  add = (date?: Date, years?: number, months?: number, days?: number) : Date | undefined => {
    if (!date) return undefined;
    const ret = date;
    if (!!years) ret.setFullYear(date.getFullYear() + years);
    if (!!months) ret.setMonth(date.getMonth() + months);
    if (!!days) ret.setDate(date.getDate() + days);
    return ret;
  }

  /** Setea un valor a una parte de una fecha */
  set = (date?: Date, year?: number, month?: number, day?: number, hour?: number, min?: number, seg?: number) : Date | undefined => {
    if (!date) return undefined;
    if (year !== null && year !== undefined) date.setFullYear(year);
    if (month !== null && month !== undefined) date.setMonth(month);
    if (day !== null && day !== undefined) date.setDate(day);
    if (hour !== null && hour !== undefined) date.setHours(hour);
    if (min !== null && min !== undefined) date.setMinutes(min);
    if (seg !== null && seg !== undefined) date.setSeconds(seg);
    return date;
  }

  /**
   * Actualiza una fecha agregando o seteando días. Primero setea y luego agrega
   * @param date fecha de inicio de proceso
   * @param set parametros de seteo
   * @param add parámetros de add
   * @returns 
   */
  upd = (date?: Date, set?: { year?: number, month?: number, day?: number, hour?: number, min?: number, seg?: number }, add?: { year?: number, month?: number, day?: number }) : Date | undefined => {
    if (!date) return undefined;
    if (!!add)
      date = this.add(date, add.year, add.month, add.day);
    if (!!set)
      date = this.set(date, set.year, set.month, set.day, set.hour, set.min, set.seg);

    return date;
  }
}
